module.exports = __webpack_public_path__ + "img/master_card.2a1417f2.png";